<style scoped>
</style>
<template>
    <div>
        <div class="row well well-sm" style="border-bottom:1px solid gray">
            <div class="col-md-8 col-sm-6 ">
                <h3 class="text-info" style="margin-top:-5px;margin-bottom:2px">{{Patient.firstName}} {{Patient.middleName}} {{Patient.lastName}}</h3>
                <table>
                    <tr><td><small><strong>Dob :</strong></small></td><td>{{FormatDate(Patient.dob)}}</td></tr>
                    <tr><td><small><strong>Nhs Id :</strong></small></td><td>{{Patient.nhsNumber}}</td></tr>
                    <tr>
                        <td><small><strong>Address :</strong></small></td>
                        <td>
                            <small>
                                <span>{{Patient.addressLine}}       </span>
                                <span>, {{Patient.postCode}}      </span>
                            </small>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="col-md-4 col-sm-6 ">
                <br />
                <div class="pull-right" style="height:100%;display: inline-block;vertical-align:bottom;float: none;">
                    <a class="btn btn-sm btn-primary" @click="CreateBag">Create Bag</a>
                    <a class="btn btn-sm btn-default" style="margin-right:10px" @click="EditPatient">Edit Patient</a>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="panel panel-default" style="margin-top:-10px">
                <div class="panel-heading">
                    <h3 class="panel-title">Patient Bags</h3>
                </div>
                <div class="panel-body">
                    <BagList :status="[10,20,30]" :patient-id="patientid" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import FmdDal from '../../../scripts/FmdDal'
    import BagList from "../BagList/baglist.scp.html"

    import Formatter from "../../corecontrols/formatters/Formatter";
    import toastr from 'toastr'
    export default {
        props: ['patientid'],
        watch: {
            patientid: function () {
                this.dal.GetPatient(this.patientid)
                    .then(p => {
                        this.Patient = p;
                    })
            }
        },
        mounted() {
            this.dal = new FmdDal(this.$root.CurrentUnitId, this.$root.UiSession);
            this.dal.GetPatient(this.patientid)
                .then(p => {
                    this.Patient = p;
                })
        },
        data: function () {
            return {
                dal: null,
                Patient: {}
            }
        },
        methods: {
            CreateBag() {
                this.dal.CreateBag(this.patientid)
                    .then(bag => {
                        console.log("New bag..... ", bag)
                        this.$router.push({ path: '/fmd/bag/' + bag.id });
                    })
            },
            EditPatient() {
                this.$router.push({ path: '/fmd/patient/edit/' + this.patientid });
            },
            FormatDate(d) {
                return Formatter.FormatDate(d);
            }
        },
        components: {
            BagList
        }
    }
</script>



// WEBPACK FOOTER //
// PatientDetail.scp.html?2651c327